import { Link } from 'react-router-dom';
import { FiStar } from 'react-icons/fi';
import ReviewList from './ReviewList';
import ReviewForm from './ReviewForm';

const ReviewsSection = ({
  book,
  reviews,
  avgRating,
  ratingDistribution,
  isAuthenticated,
  showReviewForm,
  setShowReviewForm,
  reviewData,
  setReviewData,
  reviewSort,
  setReviewSort,
  sortedReviews,
  displayReviews,
  onSubmitReview,
  onHelpful,
  helpfulReviewIds,
  helpfulPendingIds,
}) => (
  <section id="reviews" className="mt-8 grid md:grid-cols-[280px_1fr] gap-8">
    <aside>
      <h2 className="text-lg font-bold text-black mb-3">Customer reviews</h2>
      <div className="flex items-center gap-2 mb-1">
        <span className="flex items-center gap-0.5">
          {[...Array(5)].map((_, i) => (
            <FiStar
              key={i}
              className={`text-base ${
                i < Math.round(avgRating)
                  ? 'text-orange-400 fill-orange-400'
                  : 'text-black'
              }`}
            />
          ))}
        </span>
        <span className="text-sm font-semibold text-black">{avgRating} out of 5</span>
      </div>
      <p className="text-xs text-black mb-4">
        {(book.reviewCount || reviews.length).toLocaleString('en-IN')} global ratings
      </p>
      <ul className="space-y-2 list-none">
        {ratingDistribution.map(({ star, percent }) => (
          <li key={star} className="flex items-center gap-2 text-xs">
            <span className="text-blue-700 w-10">{star} star</span>
            <span className="flex-1 h-3 bg-gray-100 rounded overflow-hidden border border-gray-200">
              <span className="h-full bg-yellow-400 block" style={{ width: `${percent}%` }} />
            </span>
            <span className="text-black w-8 text-right">{percent}%</span>
          </li>
        ))}
      </ul>
      <div className="mt-5">
        {isAuthenticated ? (
          <button
            onClick={() => setShowReviewForm(!showReviewForm)}
            className="w-full text-sm border border-gray-300 rounded py-2 hover:bg-gray-50"
          >
            Write a product review
          </button>
        ) : (
          <Link
            to="/login"
            className="block w-full text-center text-sm border border-gray-300 rounded py-2 hover:bg-gray-50"
          >
            Sign in to review
          </Link>
        )}
      </div>
    </aside>

    <section>
      <header className="flex items-center justify-between mb-3">
        <h3 className="text-base font-bold text-black">Top reviews ({displayReviews.length})</h3>
        <select
          value={reviewSort}
          onChange={(e) => setReviewSort(e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-xs"
        >
          <option value="newest">Most recent</option>
          <option value="oldest">Oldest</option>
          <option value="highest">Highest rating</option>
          <option value="lowest">Lowest rating</option>
          <option value="helpful">Most helpful</option>
        </select>
      </header>

      {showReviewForm && (
        <ReviewForm
          value={reviewData}
          onChange={setReviewData}
          onSubmit={onSubmitReview}
          onCancel={() => setShowReviewForm(false)}
        />
      )}

      {sortedReviews.length === 0 ? (
        <p className="text-sm text-black">
          No reviews yet. Be the first to review this product!
        </p>
      ) : (
        <ReviewList
          reviews={sortedReviews}
          onHelpful={onHelpful}
          helpfulReviewIds={helpfulReviewIds}
          helpfulPendingIds={helpfulPendingIds}
        />
      )}
    </section>
  </section>
);

export default ReviewsSection;
